import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import de from 'vuetify/es5/locale/de';

const params = new URLSearchParams(window.location.search);

Vue.use(Vuetify, {
	options: {
		customProperties: true,
	},
	iconfont: 'md',
	theme: {
		primary: params.get('color') || '#3E9487',
	},
	lang: {
		locales: { de },
		current: 'de',
	},
});
